import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Whisper, Tooltip } from "rsuite";
import { RiListUnordered } from "react-icons/ri";
import Offcanvas from "react-bootstrap/Offcanvas";
import EmergencyFormModal from "./ClinicModal/EmergencyFormModal";
import OutPatientTable from "./OutPatientTable";
import ClinicFilterPopover from "./ClinicFilterPopover";
import {
  useLazyGetoutpatientQuery,
  useGetOutPatientDetailsQuery,
  usePostFilteredOutpatientsMutation
} from "../State/Api/GetoutpatientApiSlice";
import ClinicsideReportsfilters from "./ClinicsideReportsfilters";
import { FiUser, FiSearch, FiX } from "react-icons/fi";
import DefaultPatientFilters from "./ClinicComponent/Filters/DefaultPatientFilters";
import OutpatientViewFilters from "./ClinicComponent/Filters/ClinicFilterJSON/OutpatientView";

function OpCaseSheet() {
  const [show, setShow] = useState(false);
  const [emerShow, setEmerShow] = useState(false);
  const [EditProfShow, setEditProfShow] = useState(false);
  const [activeView, setActiveView] = useState("list");
  const [reportSearch, setReportSearch] = useState("");
    const [selectedFilters, setSelectedFilters] = useState({});
     const gridRef = useRef(null);
      const [hasData, setHasData] = useState(true);

       const clinicUserId = localStorage.getItem("userClinicID");

       const prevFiltersRef = useRef([]);
     
       useEffect(() => {
         // Only purge if filters actually changed
         if (
           JSON.stringify(prevFiltersRef.current) !== JSON.stringify(selectedFilters)
         ) {
           gridRef?.current?.api?.purgeInfiniteCache();
           prevFiltersRef.current = selectedFilters;
         }
       }, [selectedFilters]);
     

       const [fetchFilteredOutPatients, {   isLoading, isFetching, isSuccess }] =
    usePostFilteredOutpatientsMutation();
  

      const getOutPatients = async (pageNumber, filters, sortColumn = "", sortOrder = "") => {
    try {
      const result = await fetchFilteredOutPatients({
        pageNumber: pageNumber,
        pageSize: 100,
        userClinicID: clinicUserId,
        doctorUserUniqueID: "",
        filters: filters,
       sortColumn: sortColumn,
       sortOrder: sortOrder
      }).unwrap();

      return result;
    } catch (err) {

    }
  };

    useEffect(() => {
      gridRef?.current?.api?.purgeInfiniteCache();
    }, [selectedFilters]);
  
    const handleSearch = () => {
      let searchValue = reportSearch.trim();
  
      if (!searchValue) {
        // Clear filters if search empty
        setSelectedFilters((prev) => {
          const { patientName, patientUserUniqueID, ...rest } = prev;
          return rest;
        });
        return;
      }
  
      let newFilter;
  
      if (/^PLCRXPAT\d+$/i.test(searchValue)) {
        // Already formatted Patient ID
        newFilter = {
          patientUserUniqueID: {
            values: new Set([searchValue]),
            operator: "Contains",
          },
        };
      } else if (/^\d+$/.test(searchValue)) {
        // Only numbers → prepend prefix
        const prefixedValue = `PLCRXPAT${searchValue}`;
        newFilter = {
          patientUserUniqueID: {
            values: new Set([prefixedValue]),
            operator: "Contains",
          },
        };
      } else {
        // Otherwise treat as name
        newFilter = {
          patientName: {
            values: new Set([searchValue]),
            operator: "Contains",
          },
        };
      }
  
      setSelectedFilters((prev) => {
        const { patientName, patientUserUniqueID, ...rest } = prev;
        return { ...rest, ...newFilter };
      });
    };
  
    const handleClearSearch = () => {
      setReportSearch("");
      setSelectedFilters((prev) => {
        const { patientName, patientUserUniqueID, ...rest } = prev;
        return rest;
      });
      setHasData(true);
    };
  


  const navigate = useNavigate();
  // const [fetchOutPatients, { data = [], isFetching, isSuccess, isLoading }] =
  //   useLazyGetoutpatientQuery();

  // useEffect(() => {
  //   const clinicUserId = localStorage.getItem("userClinicID");
  //   if (clinicUserId) {
  //     fetchOutPatients(clinicUserId);
  //   }
  // }, []);

  const getButtonClasses = (view) => {
    const isActive = activeView === view;
    return [
      "flex-1 flex items-center justify-center h-[36px] w-[50px] transition-all",
      isActive
        ? "bg-[#203342] text-white"
        : "bg-white text-[#203342] hover:bg-gray-100",
    ].join(" ");
  };

  return (
    <>
      <main style={{ width: "100%", height: "100%" }}>
        <div className="row">
          <div
            style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }}
            className="col-12 mb-4"
          >
            <div className="d-flex justify-content-between align-items-center w-100 flex-wrap">
              {/* Left Side: Heading */}
              <div>
                <h2 className="h3 fw-bold mb-0" style={{fontSize:'24px'}}>Out Patient</h2>
                {/* <p className="text-secondary mb-0">
                  Schedule and manage patient appointments with doctors.
                </p> */}
              </div>

              {/* Right Side: Buttons */}
              <div className="d-flex align-items-center gap-3 mt-2 mt-sm-0">
                <div className="d-flex align-items-center gap-3">
                     <label className="relative">
                <input
                  type="text"
                  className="pr-20 pl-4 py-2 border border-[#7eb592] rounded-lg w-full text-sm   focus:outline-none ring-2 ring-[#7eb592]/20 focus:outline focus:border-[#7eb592] focus:ring-2 focus:ring-[#7eb592]/20"
                  placeholder="Enter patient name or ID"
                  value={reportSearch}
                  onChange={(e) => {
                    const value = e.target.value;
                    setReportSearch(value);

                    if (value.trim() === "") {
                      setSelectedFilters((prev) => {
                        const { fullName, patientIDUniqueID, ...rest } = prev;
                        return rest;
                      });
                    }
                  }}
                  onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                />
                {reportSearch && (
                  <span
                    className="absolute right-12 top-9 transform -translate-y-1/2 p-2 rounded-md text-gray-500 hover:text-red-400 cursor-pointer"
                    onClick={handleClearSearch}
                  >
                    <FiX size={16} />
                  </span>
                )}
                <span
                  className="absolute right-[0.3rem] top-9 transform -translate-y-1/2 bg-[#7eb592] hover:bg-gray-200 p-2 rounded-md text-white cursor-pointer"
                  onClick={handleSearch}
                >
                  <FiSearch size={16} />
                </span>
              </label>

                                
                                            <Whisper placement="top" trigger="hover" speaker={<Tooltip>Filter Options</Tooltip>}>
                                                <DefaultPatientFilters
                                  defaultFilters={OutpatientViewFilters.default}
                                  additionalFilters={OutpatientViewFilters.additional}
                                  selectedFilters={selectedFilters}
                                  setSelectedFilters={setSelectedFilters}
                                  setHasData={setHasData}
                                />
                                              </Whisper>
                  <div className="flex rounded-md overflow-hidden shadow-sm border border-gray-200 w-fit">
                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={<Tooltip>List view</Tooltip>}
                    >
                      <button
                        onClick={() => setActiveView("list")}
                        className={getButtonClasses("list")}
                      >
                        <RiListUnordered size={20} />
                      </button>
                    </Whisper>

                    {/* You can uncomment this for grid view */}
                    {/* <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={<Tooltip>Grid view</Tooltip>}
                    >
                      <button
                        onClick={() => setActiveView("grid")}
                        className={getButtonClasses("grid")}
                      >
                        <RiGridFill size={20} />
                      </button>
                    </Whisper> */}
                  </div>

                  {/* <Whisper
                    placement="top"
                    trigger="hover"
                    speaker={<Tooltip>Filter Options</Tooltip>}
                  >
                    <div>
                      <ClinicFilterPopover />
                    </div>
                  </Whisper> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table View */}
        {activeView === "list" && (
          <OutPatientTable
            getOutPatients={getOutPatients}
            isFetching={isFetching}
            isLoading={isLoading}
            isSuccess={isSuccess}
            gridRef={gridRef}
            selectedFilters={selectedFilters}
            hasData={hasData}          
            setHasData={setHasData} 
          />
        )}
      </main>

      {/* Emergency Modal */}
      <EmergencyFormModal emerShow={emerShow} setEmerShow={setEmerShow} />
    </>
  );
}

export default OpCaseSheet;
